import { useLoginMutation } from '@/services/api.service';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { useLocalStorage } from './useLocalStorage.hook';

export const useAuth = () => {
  const {
    value: jwt,
    setItem: setJWT,
    removeItem: removeJWT,
  } = useLocalStorage<string>(StorageKeysEnum.jwt);

  const [triggerLogin, { isLoading }] = useLoginMutation();

  return {
    jwt,
    login: triggerLogin,
    loginIsLoading: isLoading,
    removeJWT,
    setJWT,
  };
};
